import React from "react";
import { CHIP_COLOR_TYPES, CustomChip } from "~/components/chips/CustomChip.jsx";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import { customerHasAnyFlags } from "~/cores/customerCore";

export default function CustomerFlagChips({ customer, direction = "column", style }) {
    if (!customerHasAnyFlags(customer)) return null;
    return (
        <div style={{ display: "flex", flexDirection: direction, gap: 4, ...style }}>
            {customer.blacklisted && (
                <TurnrTooltip content="Blocked from registering returns">
                    <CustomChip size="small" colorType={CHIP_COLOR_TYPES.ERROR} label="Blacklisted" disableTooltip />
                </TurnrTooltip>
            )}
            {customer.blockEarlyCompensation && (
                <TurnrTooltip content="Always waits for warehouse confirmation before refund or exchange">
                    <CustomChip size="small" colorType={CHIP_COLOR_TYPES.WARNING} label="Early comp. blocked" disableTooltip />
                </TurnrTooltip>
            )}
        </div>
    );
}
